
export enum StackedChartTypesEnum {
    VOLUME = 'VOLUME',
    PERCENTAGE = 'PERCENTAGE',
}

